<template>
<div v-if="team && roster">
    <playerPurchaseModal v-if="showPlayerPurchaseModal" :team="team" :roster="roster" :purchaseList="playerToPurchase" @closeMessage="showPlayerPurchaseModal = false" @validate='updatePlayerPurchases'></playerPurchaseModal>
            <div class="text-left panel-title">
                Joueurs
            </div>
            <table v-if="roster">
                <thead>
                    <tr class="">
                        <th width="60"></th>
                        <th width="150">
                        </th>
                        <th width="100">Prix</th>
                        <th width="10">M</th>
                        <th width="10">F</th>
                        <th width="10">Ag</th>
                        <th width="10">Ar</th>
                        <th width="250">Compétences</th>
                        <th with="200">Qté</th>
                        <th with="150">coût total</th>
                        <th width="20"></th>
                        <th width="20"></th>
                    </tr>
                </thead>
                <tbody class="roster" v-if="roster">
                    <tr v-for="line of roster.roster_lines">
                        <td>0-{{line.max}}</td>
                        <td>{{line.position}}</td>
                        <td>{{line.cost}} 000</td>
                        <td>{{line.M}}</td>
                        <td>{{line.F}}</td>
                        <td>{{line.Ag}}</td>
                        <td>{{line.Ar}}</td>
                        <td>
                            <span v-for="skill of line.base_skills" >
                                {{skill.name}},
                            </span>
                        </td>
                        <td v-if="playerList[line.id]">{{playerList[line.id].toBuy}}</td>
                        <td v-else>0</td>
                        <td>{{getLineCount(line) * line.cost }} 000</td>
                        <td v-if="isMax(line) == false" class="action">
                            <button v-if="canAddLine(line)" class="action" v-on:click="addLine(line) " >+</button>
                            <button v-else class="deactivated action" disabled>+</button>
                        </td>
                        <td v-else class="action">
                        </td>
                        <td v-if="isMax(line) == false" class="action">
                            <button v-if="canRemoveLine(line)" v-on:click="removeLine(line)" class="action">-</button>
                            <button v-else class="deactivated action" disabled >-</button>
                        </td>
                        <td v-else class="action">
                        </td>
                    </tr>

                    <tr>
                        <td colspan="8" class="sous-total right">Budget Joueurs</td>
                        <td class="sous-total">{{totalPlayer}}</td>
                        <td class="sous-total">{{totalPlayerCost}} 000</td>
                        <td colspan="2"></td>
                    </tr>
                </tbody>
            </table>
            <template v-if="journeyMenList.length > 0">
                <div class="text-left panel-title">
                    Journaliers
                </div>
              <table>
                <thead class="roster">
                <tr>
                  <th width="40">N°</th>
                  <th width="100">Nom</th>
                  <th width="100">Position</th>
                  <th width="5">M</th>
                  <th width="5">F</th>
                  <th width="5">Ag</th>
                  <th width="5">Ar</th>
                  <th width="225">Compétences</th>
                  <th width="225">Evolutions</th>
                  <th width="10">Réu</th>
                  <th width="10">Td</th>
                  <th width="10">Int</th>
                  <th width="10">Sor</th>
                  <th width="10">Mvp</th>
                  <th width="20">Xp</th>
                  <th width="50">Prix</th>
                  <th></th>
                </tr>
                </thead>
                <tbody class="roster">
                <tr v-for="player in journeyMenList">
                  <td v-bind:class="{ miss: player.miss_next_game }" class="number">{{player.num}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >{{player.name}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >{{player.ref_roster_line}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >{{player.M}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >{{player.F}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ag}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ar}}</td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >
                                <span v-for="skill in player.skills" >
                                        {{skill.name}},
                                </span>
                  </td>
                  <td v-bind:class="{ miss: player.miss_next_game }" >
                                <span v-if="player.upgrades.length" v-for="up in player.upgrades" :class="getUpgradeStyle(up)" >
                                        {{getUpgradeName(up)}},
                                </span>
                    <span v-if="player.downgrades" class="upgrade down">
                                        {{getDowngrades(player)}},
                                </span>
                    <div v-if="player.customizations && player.customizations.length"
                         v-for="cust in player.customizations" class="upgrade stats">
                      <span v-if="cust.skills" v-for="skill in cust.skills">{{skill.name}}, </span>
                    </div>
                  </td>
                  <td>{{player.nb_passes}}</td>
                  <td>{{player.nb_TD}}</td>
                  <td>{{player.nb_int}}</td>
                  <td>{{player.nb_cas}}</td>
                  <td>{{player.nb_MVP}}</td>
                  <td>{{player.total_xp}}</td>
                  <td><span  v-bind:class="{ miss: player.miss_next_game }" class="additional_skills">{{player.base_cost + player.evolution_cost}}k</span></td>
                  <td class="action">
                    <button v-if="isJourneymanPurchasable(player)" @click="addJmToCart(player)" :disabled="!canBuyJourneyman" class="small action">
                      <span :id="player.id">
                        <i class="fa fa-plus med-size" aria-hidden="true" :id="player.id"></i>
                      </span>
                    </button>
                    <button v-else @click="removeJmFromCart(player)" class="small action">
                      <span :id="player.id">
                        <i class="fa fa-minus med-size" aria-hidden="true" :id="player.id"></i>
                      </span>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </template>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import spinner from '../../common/spinner.vue'
import messageModal from '../../common/message-modal.vue'
import playerPurchaseModal from '../../common/player-purchase-modal.vue'

export default {
  name: 'PlayerPurchase',
  components: {
    spinner,
    messageModal,
    playerPurchaseModal
  },
  props: {
    'roster': {},
    'team': {},
    'currentTreasury': 0
  },
  data () {
    return {
      // la liste des joueurs actuellement présents dans l'équipe, et de ceux que l'on achète
      playerList: [],
      journeymenToPurchase: [],
      playerToPurchase: [],
      showPlayerPurchaseModal: false,
      playerToBuyCount: 0
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'detailedTeam'
    ]),
    getLineCount: function () {
      var vm = this
      return function (line) {
        if (vm.playerList[line.id]) {
          return vm.playerList[line.id].toBuy
        }
        return 0
      }
    },
    totalPlayer: function () {
      if (this.roster === null) {
        return 0
      }
      let totalPlayer = 0
      for (var line of this.roster.roster_lines) {
        if (this.playerList[line.id]) {
          totalPlayer += this.playerList[line.id].toBuy
        }
      }
      return totalPlayer
    },
    totalPlayerCost: function () {
      if (this.roster === null) {
        return 0
      }
      let totalPlayerCost = 0
      for (let line of this.roster.roster_lines) {
        if (this.playerList[line.id]) {
          totalPlayerCost += this.playerList[line.id].toBuy * line.cost
        }
      }
      if (this.journeymenToPurchase.length > 0) {
        totalPlayerCost += this.journeymenToPurchase.length * this.roster.journeyman.cost
      }
      return totalPlayerCost
    },
    journeyMenList: function () {
      if (!this.detailedTeam) {
        return []
      }
      let list = this.detailedTeam.players.filter(pl => {
        return pl.is_journeyman === true
      })
      return list
    },
    canBuyJourneyman: function () {
      // on vérifie que le pognon restant est suffisant pour acheter un journalier
      return this.currentTreasury >= this.roster.journeyman.cost
    }
  },
  mounted () {
    if (!this.team || !this.roster) {
      return
    }
    // on initialise la liste des type de lignes
    this.roster.roster_lines.forEach(rl => {
      let line = {}
      line.id = rl.id
      line.position = rl.position
      line.count = 0
      line.toBuy = 0
      Vue.set(this.playerList, line.id, line)
    })

    // on compte les joueurs, par type
    this.team.players.forEach(player => {
      // on choppe la ligne de la structure qui correspond
      let playerLine = this.playerList.find(f => f !== undefined && f.position === player.ref_roster_line)
      playerLine.count = playerLine.count + 1
      Vue.set(this.playerList, playerLine.id, playerLine)
    })

    this.isInit = true
  },
  methods: {
    getUpgradeStyle: function (upgrade) {
      if (upgrade.type === 0) {
        return 'upgrade base'
      }
      if (upgrade.type === 1) {
        if (upgrade.value === 0) {
          return 'upgrade simple'
        }
        if (upgrade.value === 1) {
          return 'upgrade double'
        }
        if (upgrade.value > 1) {
          return 'upgrade stats'
        }
      }
    },
    getUpgradeName: function (upgrade) {
      if (upgrade.status === 0) {
        return ''
      }
      if (upgrade.value === 0 || upgrade.value === 1) {
        return upgrade.skill
      }
      if (upgrade.value === 2) {
        return '+1 M'
      }
      if (upgrade.value === 3) {
        return '+1 Ar'
      }
      if (upgrade.value === 4) {
        return '+1 Ag'
      }
      if (upgrade.value === 5) {
        return '+1 F'
      }
    },
    isJourneymanPurchasable: function (jm) {
      if (this.journeymenToPurchase.length < 0) {
        return true
      }
      let index = this.journeymenToPurchase.findIndex(jmtp => {
        return jmtp.id === jm.id
      })
      if (index !== -1) {
        return false
      }
      return true
    },
    addJmToCart: function (jm) {
      let jmDatas = {}
      jmDatas.id = jm.id
      jmDatas.name = jm.name
      jmDatas.num = jm.num
      this.journeymenToPurchase.push(jmDatas)
      this.$emit('updatePlayerCost')
    },
    removeJmFromCart: function (jm) {
      let index = this.journeymenToPurchase.findIndex(jmtp => {
        return jmtp.id === jm.id
      })
      this.journeymenToPurchase.splice(index, 1)
      this.$emit('updatePlayerCost')
    },
    // ajoute un joueur du type qui va bien
    addLine: function (line) {
      let newVal = this.playerList[line.id]
      newVal.toBuy = newVal.toBuy + 1
      Vue.set(this.playerList, line.id, newVal)
      this.$emit('updatePlayerCost')
      this.playerToBuyCount += 1
    },
    // enlève un joueur du type qui va bien
    removeLine (line) {
      if (this.playerList[line.id].toBuy > 0) {
        let newVal = this.playerList[line.id]
        newVal.toBuy = newVal.toBuy - 1
        Vue.set(this.playerList, line.id, newVal)
        this.$emit('updatePlayerCost')
        this.playerToBuyCount -= 1
      }
    },
    actualPlayers () {
      let playersCount = this.team.players.length
      if (this.team.rostered_star_player) {
        playersCount += 1
      }
      return playersCount
    },
    futurePlayingPlayers () {
      return this.playerToBuyCount + this.actualPlayers()
    },
    isMax (line) {
      if (this.playerList[line.id] && (this.playerList[line.id].count === line.max)) {
        return true
      }
      return false
    },
    // peut-on enlever un joueur ?
    canRemoveLine: function (line) {
      if (this.playerList.length === 0) {
        return false
      }

      if (this.playerList[line.id] && this.playerList[line.id].toBuy > 0) {
        return true
      }
      return false
    },
    // peut-on ajouter un joueur ?
    canAddLine: function (line) {
      if (!this.playerList[line.id] || (this.playerList[line.id].count + this.playerList[line.id].toBuy < line.max)) {
        if (this.roster.roster_lines.find(rl => rl.id === line.id).cost > this.currentTreasury || this.futurePlayingPlayers() === 16) {
          return false
        }
        return true
      }
      return false
    },
    getDatas () {
      /*
      "hire": {
        "journeymen": [
          {
            "name":"le gros JM",
            "num":14,
            "id":106
          }
        ],
        "players": [
          {
            "name":"le gros JM",
            "num":14,
            "ref_roster_line" : 82
          },
          {
            "name":"le gros TQ",
            "num":16,
            "ref_roster_line" : 82
          }
        ]
      }
      */
      let hireStruct = {}
      // si on achjète des joueurs, on ajoute la section joueurs
      if (this.playerList.find(player => player !== undefined && player.toBuy > 0)) {
        hireStruct.players = []
        this.playerList.forEach(player => {
          if (player.toBuy > 0) {
            for (let i = 0; i < player.toBuy; i++) {
              let playerToBuy = {}
              playerToBuy.name = ''
              playerToBuy.num = 0
              playerToBuy.ref_roster_line = player.id
              hireStruct.players.push(playerToBuy)
            }
          }
        })
      }
      //  si on achète des journaliers, on  ajoute la section journeymen
      if (this.journeymenToPurchase.length > 0) {
        hireStruct.journeymen = []
        this.journeymenToPurchase.forEach(jm => {
          hireStruct.journeymen.push(jm)
        })
      }
      return hireStruct
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}


.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
  .med-size {
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// player-purchase.vue?683c4875